/* GLADIATOR HOOPS — global.js */
/* NOTE: the mobile nav drawer is owned by sections/header.liquid (inline script).
   It was removed from here so the two never double-bind the burger button. */
(function () {
  'use strict';

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.gh-reveal');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- quantity steppers ---------- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-step]');
      if (!b) return;
      var input = b.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var step = parseInt(b.getAttribute('data-qty-step'), 10) || 1;
      var v = (parseInt(input.value, 10) || 0) + step;
      var min = parseInt(input.min || '0', 10);
      if (v < min) v = min;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- product form: variant picker ---------- */
  function money(cents, format) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function initProductForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (root) {
      var dataEl = root.querySelector('[data-product-json]');
      if (!dataEl) return;
      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var selects = Array.prototype.slice.call(root.querySelectorAll('[data-option-select]'));
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare-price]');
      var btn = root.querySelector('[data-add-btn]');
      var format = root.getAttribute('data-money-format') || '${{amount}}';

      function currentVariant() {
        var opts = selects.map(function (s) { return s.value; });
        return product.variants.find(function (v) {
          return opts.every(function (val, i) { return v.options[i] === val; });
        });
      }

      function update() {
        var v = currentVariant();
        if (!v) {
          if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price, format);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = money(v.compare_at_price, format);
            compareEl.hidden = false;
          } else { compareEl.hidden = true; }
        }
        if (btn) {
          btn.disabled = !v.available;
          btn.textContent = v.available ? 'Add to cart' : 'Sold out';
        }
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', update); });

      var params = new URLSearchParams(window.location.search);
      var pre = params.get('variant');
      if (pre) {
        var match = product.variants.find(function (v) { return String(v.id) === pre; });
        if (match) {
          match.options.forEach(function (val, i) { if (selects[i]) selects[i].value = val; });
        }
      }
      update();
    });
  }

  /* ---------- product gallery ---------- */
  function initGalleries() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-gallery-main] img');
      g.addEventListener('click', function (e) {
        var t = e.target.closest('[data-gallery-thumb]');
        if (!t || !main) return;
        main.src = t.getAttribute('data-full');
        main.alt = t.querySelector('img') ? t.querySelector('img').alt : '';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initQty();
    initProductForms();
    initGalleries();
  });
})();